// #region Imports
import { defineComponent, nextTick } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Vars
    name: 'g-catalog-product',
    // #endregion
    // #region Properties
    data: () => ({
        //System
        currentItem: null,
        currentItemNumber: '',
        //Data
        isLoading: true,
        isLoadingRelations: true,
        //relations
        relations: {},
        relatedProducts: [],
        relatedCatageories: [],
        //Custom
        product: {},
        productImages: [],
        selectedItems: [],
        //Selection
        entryData: {
            quantity: 1,
            files: [],
            selection: {},
            options: [],
            custom: {}
        },
    }),
    computed: {
        currentTitle() {
            return this.product?.title + ' (' + this.currentItem?.itemNumber + ')';
        },
        __texte() {
            let tItems = [];
            if (this.product?.texte?.scope1?.items && this.product.texte.scope1.items.length > 0) {
                this.product?.texte?.scope1?.items.forEach((e) => {
                    if (!tItems.some(f => f.name === e.name)) {
                        tItems.push(e);
                    }
                });
            }
            if (this.currentItem?.itemNumber !== this.product.itemNumber) {
                if (this.currentItem?.texte?.scope1?.items && this.currentItem.texte.scope1.items.length > 0) {
                    this.currentItem?.texte?.scope1?.items.forEach((e) => {
                        if (!tItems.some(f => f.name === e.name)) {
                            tItems.push(e);
                        }
                    });
                }
            }
            return tItems;
        }
    },
    // #endregion
    // #region Constructor
    created() {
        this.loadData();
    },
    beforeMount() {
        this.$host.eventBus.on('refresh', this.loadData);
    },
    beforeUnmount() {
        this.$host.eventBus.off('refresh', this.loadData);
    },
    // #endregion
    // #region Watch
    watch: {
        'currentItem': function (value) {
            //Quantity
            this.entryData.quantity = value?.quantityData?.min;
            if (value && value.isReal) {
                this.currentItemNumber = value?.itemNumber;
            }
            else {
                this.currentItemNumber = '';
            }
            //Optimiz
            if (!this.entryData.quantity || this.entryData.quantity == 0) {
                this.entryData.quantity = 1;
            }
            //Relations
            this.refreshRelations();
        },
        'currentItemNumber': function (value) {
            this.updateItemInQuery();
        },
        '$data.relatedProducts': function (value) {
            this.$refs.accessories?.reload();
        },
        '$route.params.productID': function (value) {
            if (utils.isNullOrEmpty(value)) {
                return;
            }
            this.loadData();
        },
        '$route.query.item': function (value) {
            if (utils.isNullOrEmpty(value)) {
                return;
            }
            if (value === this.currentItemNumber) {
                return;
            }
            this.setItemByNumber(value);
        },
    },
    // #endregion
    // #region Core
    methods: {
        // #region Loading
        async loadData() {
            // #region Products
            this.loadProducts();
            // #endregion
            // #region Relations
            this.loadRelations();
            // #endregion
        },
        async loadProducts() {
            // #region Vars
            this.isLoading = true;
            // #endregion
            // #region Args
            let tArgs = {};
            {
                if (this.$route.params?.catalogID) {
                    tArgs.catalogID = this.$route.params?.catalogID;
                }
                if (!utils.isNullOrEmpty(this.$route.params?.categoryID)) {
                    tArgs.categoryID = this.$route.params?.categoryID;
                }
            }
            // #endregion
            // #region Load
            host.api.get(`commerce/products/${this.$route.params.productID}`, { params: tArgs })
                .then((e) => {
                if (e.status === 204) {
                    //Redirect
                    this.$router.push('/');
                    //Result
                    this.isLoading = false;
                    return;
                }
                if (!e.data) {
                    this.isLoading = false;
                    return;
                }
                //Product                        
                this.product = e.data;
                this.productImages = this.product.images;
                //Breadcrumb
                this.$store.commit('navigation/setBreadcrumb', e.data.breadcrumb);
                this.$host.pageMeta.setMeta({
                    title: this.product?.title,
                    meta: this.product?.seo
                });
                //Set
                if (this.$route.query.item) {
                    nextTick(() => this.setItemByNumber(this.$route.query.item));
                }
                //Run
                this.isLoading = false;
            }).catch(e => {
                this.isLoading = false;
                host.notification.showToast(utils.getAxiosErrorMessage(e), "error");
            });
            // #endregion
        },
        // #endregion
        // #region Cart
        async AddItemToCart(type) {
            // #region Check
            if (!this.currentItem) {
                return;
            }
            if (!this.currentItem.isReal) {
                return;
            }
            if (type === 'A') {
                if (!this.currentItem.canRequest) {
                    return;
                }
            }
            else {
                if (!this.currentItem.canOrder) {
                    return;
                }
            }
            // #endregion
            // #region Form
            let tForm = this.$refs['frmOrder']?.$form;
            {
                if (tForm) {
                    if (!tForm.validate()) {
                        this.$host.notification.showToast(this.$tc('client.Commerce.Products.' + (type === 'A' ? 'AddToRequestNotValid' : 'AddToCartNotValid')), "warning");
                        return;
                    }
                }
            }
            // #endregion
            // #region Data
            //Vars
            let tLine = {
                itemType: 'SKU',
                itemNumber: this.currentItem?.itemNumber,
                quantity: this.entryData?.quantity ?? 0,
                singlePrice: this.currentItem?.price,
                priceUnit: this.currentItem?.priceUnit,
                catalogID: this.product?.catalogID,
                files: this.entryData.files,
                selectedData: this.entryData.selection,
                userData: this.entryData.custom,
                imageAddress: this.productImages && this.productImages.length > 0 ? this.productImages[0]?.address : null,
                options: this.entryData.options
            };
            let tCart = {
                cartType: type,
                cartID: this.$host.store.getter(type === 'A' ? 'carts/requestID' : 'carts/cartID'),
                accountID: this.$host.store.getter("session/accountID"),
                userID: this.$host.store.getter("session/userID"),
                lines: [tLine]
            };
            let tArgs = {
                cancel: false,
                cart: tCart,
                line: tLine
            };
            //Fill
            await host.eventBus.emit('add-to-cart', tArgs);
            if (tArgs.cancel) {
                return;
            }
            // #endregion
            // #region Send
            try {
                //Upload
                let tResult = await host.api.post('commerce/carts?mode=ifnotexists', tCart);
                //Set
                if (tResult?.data) {
                    this.$store.commit('carts/setCart', tResult.data);
                }
                //Reset
                await this.reset();
                //Notify
                host.notification.showToast(this.$tc('client.Commerce.Products.' + (type === 'A' ? 'AddedToRequest' : 'AddedToCart')));
            }
            catch (e) {
                host.notification.showError(e);
            }
            // #endregion
        },
        // #endregion
        // #region Relations
        async loadRelations() {
            // #region Vars
            this.isLoadingRelations = true;
            // #endregion
            // #region Load
            host.api.get(`commerce/products/${this.$route.params.productID}/relations`)
                .then((e) => {
                //Product
                this.relations = e.data;
                this.refreshRelations();
                //Run
                this.isLoadingRelations = false;
            }).catch(e => {
                this.relations = [];
                this.isLoadingRelations = false;
            });
            // #endregion
        },
        refreshRelations() {
            // #region Check
            if (!this.relations) {
                this.relatedCatageories = [];
                this.relatedProducts = [];
                return;
            }
            // #endregion
            // #region Default
            if (!this.currentItem || !this.currentItem.isReal) {
                this.relatedProducts = this.relations?.products ?? [];
                this.relatedCatageories = this.relations?.categories ?? [];
            }
            // #endregion
            // #region Filter
            else {
                this.relatedProducts = this.relations.products?.filter((e) => {
                    return !e.relatedItems || e.relatedItems.length === 0 || e.relatedItems.some(f => f === this.currentItem?.itemNumber);
                });
                this.relatedCatageories = this.relations.categories?.filter((e) => {
                    return !e.relatedItems || e.relatedItems.length === 0 || e.relatedItems.some(f => f === this.currentItem?.itemNumber);
                });
            }
            // #endregion
        },
        // #endregion
        // #region Images
        OnCurrentImageChanged(images) {
            // #region Vars
            let tData = [];
            let tMode = this.$host.options.get('ecommerce_product_imageMode', this.product.options);
            // #endregion   
            // #region Image
            if (images) {
                images.forEach((e) => {
                    tData.push(e);
                });
            }
            // #endregion                
            // #region Product (Mode: Product)
            if (this.product?.images && tMode === 'product') {
                // #region Cache
                let tImageCache = [];
                // #endregion
                // #region Item
                if (this.currentItem && this.currentItem.itemNumber !== this.product.itemNumber) {
                    this.product.images.forEach((e) => {
                        // #region Validate
                        if (e.itemNumbers && e.itemNumbers.length > 0) {
                            if (e.itemNumbers.some((f) => { return this.product.itemNumber === f; })) {
                                return;
                            }
                            if (!e.itemNumbers.some((f) => { return this.currentItem.itemNumber === f; })) {
                                return;
                            }
                        }
                        // #endregion
                        tData.push(e);
                        tImageCache.push(e.name);
                    });
                }
                // #endregion
                // #region Product
                this.product.images.forEach((e) => {
                    // #region Validate
                    if (tImageCache.some(f => f == e.name)) {
                        return;
                    }
                    if (e.itemNumbers && e.itemNumbers.length > 0) {
                        let tValue = e.itemNumbers.some((f) => { return this.product.itemNumber === f; });
                        if (!tValue) {
                            return;
                        }
                    }
                    // #endregion
                    //Append
                    tData.push(e);
                });
                // #endregion
            }
            // #endregion
            // #region Product
            else if (this.product?.images) {
                this.product.images.forEach((e) => {
                    if (e.itemNumbers && e.itemNumbers.length > 0) {
                        let tValue = e.itemNumbers.some((f) => {
                            return this.selectedItems.some(g => g.itemNumber === f);
                        });
                        if (!tValue) {
                            return;
                        }
                    }
                    tData.push(e);
                });
            }
            // #endregion
            // #region Set
            if (tData.length > 0) {
                this.productImages = tData;
            }
            // #endregion
        },
        async OnCustomItemChanged() {
            try {
                //Args
                let tArgs = {
                    itemNumber: this.currentItem?.itemNumber
                };
                //Data
                let tData = {
                    quantity: this.entryData.quantity,
                    selection: this.entryData.selection,
                    options: this.entryData.options,
                    custom: this.entryData.custom
                };
                //Load
                let tResult = await this.$host.api.post(`commerce/products/${this.$route.params.productID}/get-price`, tData, { params: tArgs });
                //Set
                if (tResult?.data && tResult.data.__reset === true) {
                    if (this.currentItem._isCustom) {
                        if (this.product.itemNumber === this.currentItem.itemNumber) {
                            this.currentItem = this.product;
                        }
                        else {
                            this.currentItem = this.product.variants.find((e) => e.itemNumber == this.currentItem.itemNumber);
                        }
                    }
                }
                else if (tResult?.data) {
                    //Merge
                    this.$utils.mergeDeep(this.currentItem, tResult.data);
                    //Custom
                    this.currentItem._isCustom = true;
                }
            }
            catch (e) {
                this.$host.notification.showError(e);
            }
        },
        // #endregion
        // #region Tools
        async reset() {
            this.entryData.files = [];
        },
        isEmpty(object) {
            return utils.isEmpty(object);
        },
        hasVariants(product) {
            if (product === undefined || product.variants === undefined) {
                return false;
            }
            return product.variants.length > 0;
        },
        setItemByNumber(itemNumber) {
            this.currentItemNumber = itemNumber;
        },
        updateItemInQuery() {
            if (this.$route.query.item && this.$route.query.item != this.currentItemNumber) {
                //new
                let tQuery = Object.assign({}, this.$route.query);
                //Set
                if (!this.currentItemNumber) {
                    delete tQuery["item"];
                }
                else {
                    tQuery["item"] = this.currentItemNumber;
                }
                this.$router.push({ query: tQuery });
            }
        },
        OnRefresh(event) {
            //Default
            event.preventDefault();
            //Notify
            this.$host.eventBus.emit('refresh');
        },
        // #endregion
        // #region Commands
        async OnCommand(cmd, args) {
            if (cmd === 'selector_item_changed') {
                this.currentItem = utils.cloneDeep(args?.item);
                this.selectedItems = args?.items ?? [];
            }
            else if (cmd === 'selector_image_changed') {
                this.OnCurrentImageChanged(args?.images);
            }
            else if (cmd === 'selector_configuration_changed') {
                this.OnCustomItemChanged();
            }
        }
        // #endregion
    }
    // #endregion
});
// #endregion
